<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">需要控温</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="temperFlag">
                        <el-radio :label="true">需要</el-radio>
                        <el-radio :label="false">不需要</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="temperFlag">
                <div class="form-label">
                    <label class="required">温度低值(°c)</label>
                </div>
                <div class="form-value width-3x">
                    <el-input class="inline-block width-1-5x" v-model="temperLow" placeholder="请输入温度" @change="temperLowChange()"></el-input>
                    <span class="inline-block font-orange">只保留两位小数</span>
                </div>
            </div>
            <div class="form-group center" v-if="temperFlag">
                <div class="form-label">
                    <label class="required">温度高值(°c)</label>
                </div>
                <div class="form-value width-3x">
                    <el-input class="inline-block width-1-5x" v-model="temperHigh" placeholder="请输入温度" @change="temperHighChange()"></el-input>
                    <span class="inline-block font-orange">只保留两位小数</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    //
    export default {
        name: 'swb-set-temper-info',
        avlScopes: 'retailer',
        desc: '设置温控信息',
        data: function () {
            return {
                temperFlag: true,
                temperLow: null,
                temperHigh: null
            }
        },
        created: function () {
        },
        methods: {
            // 温度低值校验
            temperLowChange: function () {
                let temperLow = this.temperLow;
                if(!Utils.isNoB(temperLow)) {
                    let low = temperLow;
                    if(low.indexOf('-') > -1) {
                        low = low.substring(1, low.length);
                    }
                    if(Utils.isMoneyStr(low)) {
                        let temperLowF = parseFloat(temperLow);
                        this.temperLow = temperLowF.toFixed(2);
                        let temperHigh = this.temperHigh;
                        if(!Utils.isNoB(temperHigh)) {
                            let temperHighF = parseFloat(temperHigh);
                            if(temperLowF > temperHighF) {
                                this.temperLow = null;
                                MsgBox.warning("温度低值要小于温度高值!");
                            }
                        }
                    } else {
                        this.temperLow = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                }
            },
            // 温度高值校验
            temperHighChange: function () {
                let temperHigh = this.temperHigh;
                if(!Utils.isNoB(temperHigh)) {
                    let high = temperHigh;
                    if(high.indexOf('-') > -1) {
                        high = high.substring(1, high.length);
                    }
                    if(Utils.isMoneyStr(high)) {
                        let temperHighF = parseFloat(temperHigh);
                        this.temperHigh = temperHighF.toFixed(2);
                        let temperLow = this.temperLow;
                        if(!Utils.isNoB(temperLow)) {
                            let temperLowF = parseFloat(temperLow);
                            if(temperLowF > temperHighF) {
                                this.temperHigh = null;
                                MsgBox.warning("温度高值要大于温度低值!");
                            }
                        }
                    } else {
                        this.temperHigh = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                }
            },
            // 温控信息返回数据
            getDlgResult: function () {
                //
                let result = {};
                let temperFlag = this.temperFlag;
                let temperLow = this.temperLow;
                let temperHigh = this.temperHigh;
                if(Utils.isTrue(temperFlag)) {
                    if(Utils.isNoB(temperHigh)) {
                        result.type = "wran";
                        result.message = "请输入温度高值!";
                        return result;
                    }
                    if(Utils.isNoB(temperLow)) {
                        result.type = "wran";
                        result.message = "请输入温度低值!";
                        return result;
                    }
                } else {
                    temperLow = null;
                    temperHigh = null;
                }
                let temperInfo = {
                    temperFlag: temperFlag,
                    temperLow: temperLow,
                    temperHigh: temperHigh
                };
                result.type = 'info';
                result.data = temperInfo;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/SetTemperInfo.vue